import React from "react"

import { Form, useLoaderData, useNavigate } from "react-router-dom"

import { Bee } from "~/src/components/BeeKit"
import { Modal } from "~/src/components/Modal"

export type StoreItemInventoryVariant = {
  id: string
  name: string
  quantity: number
}

export type DashboardStoreInventoryReorderModalProps = {
  open?: boolean
  onClose?: () => void
  variants?: StoreItemInventoryVariant[]
}

//region Component
export function DashboardStoreInventoryReorderModal({
  open = true,
  onClose,
}: DashboardStoreInventoryReorderModalProps) {
  const data = useLoaderData<DashboardStoreInventoryReorderModalProps>()

  // TODO next PR: use this to display the variants in the modal UI
  const { variants } = data

  const navigate = useNavigate()

  const handleClose = () => {
    if (onClose) {
      onClose()
    } else {
      navigate("..", { preventScrollReset: true })
    }
  }
  //endregion

  //region JSX
  return (
    <Modal open={open} onClose={handleClose} className="w-[36rem] overflow-auto bg-white" usePortal={false}>
      <Form method="post" className="flex flex-col gap-4">
        <hgroup className="flex flex-col gap-2">
          <h2 className="text-2xl font-medium">Reorder</h2>
          <p className="text-gray-700">Select the items you want to reorder. You can select multiple items at once.</p>
        </hgroup>

        {/* TODO in next PR: Display data from variants based on Figma design */}

        <div className="flex flex-col gap-3">
          <Bee.Button type="submit" className="w-full md:w-auto">
            Add to project request
          </Bee.Button>
        </div>
      </Form>
    </Modal>
  )
  //endregion
}
//endregion

//region Private
//endregion
